import {
    DemandOrderDto,
    OrderDto,
    OrderStatus,
    ReturnOrderDto,
    SiteDto,
    SpecializedOrderStatus,
} from '../../api/ClientApi';

/**
 * "Moji zadaci": ono što čeka potez ulogovanog korisnika. Ista pravila kao akcije u
 * OrdersTableMenu, samo primenjena na DTO-ove da bi se lista unapred filtrirala.
 */
export type TaskContext = {
    employeeId?: string;
    isProjectManager: boolean;
    isWarehouseManager: boolean;
    isWarehouseOwner: boolean;
    /** Za nalog čiji site nije učitan sa svim poljima; koristi se kao rezerva. */
    sites?: SiteDto[] | null;
};

function resolveSite(
    site: SiteDto | undefined,
    siteId: number | undefined,
    sites?: SiteDto[] | null,
): SiteDto | undefined {
    if (site?.warehouseOwnersAzObjIds || site?.project) {
        return site;
    }
    return sites?.find((s) => s.id === (site?.id ?? siteId)) ?? site;
}

function includesMe(ids: string[] | undefined, employeeId?: string): boolean {
    return !!employeeId && !!ids && ids.includes(employeeId);
}

/** Nalog za prenos/prijem na kojem je sledeći korak moj. */
export function isOrderWaitingForMe(order: OrderDto, ctx: TaskContext): boolean {
    const origin = resolveSite(order.originSite, order.originSiteId, ctx.sites);
    const destination = resolveSite(order.destinationSite, order.destinationSiteId, ctx.sites);

    switch (order.orderStatus) {
        case OrderStatus.Idle:
            return ctx.isProjectManager && includesMe(origin?.project?.projectManagersAzObjIds, ctx.employeeId);
        case OrderStatus.Pending:
        case OrderStatus.Approved:
            return ctx.isWarehouseOwner && includesMe(origin?.warehouseOwnersAzObjIds, ctx.employeeId);
        case OrderStatus.Transport:
            return ctx.isWarehouseOwner && includesMe(destination?.warehouseOwnersAzObjIds, ctx.employeeId);
        default:
            return false;
    }
}

const openSpecializedStatuses = [SpecializedOrderStatus.Created, SpecializedOrderStatus.InProgress];

/** Trebovanje koje PM/WM treba da pretvori u nalog ili zatvori. */
export function isDemandOrderWaitingForMe(order: DemandOrderDto, ctx: TaskContext): boolean {
    return (
        (ctx.isProjectManager || ctx.isWarehouseManager) &&
        !!order.demandOrderStatus &&
        openSpecializedStatuses.includes(order.demandOrderStatus)
    );
}

/** Povratnica koju PM/WM treba da pretvori u nalog ili zatvori. */
export function isReturnOrderWaitingForMe(order: ReturnOrderDto, ctx: TaskContext): boolean {
    return (
        (ctx.isProjectManager || ctx.isWarehouseManager) &&
        !!order.returnOrderStatus &&
        openSpecializedStatuses.includes(order.returnOrderStatus)
    );
}
